<igx-select [(ngModel)]="selectedMoneda" [style.width]="width" [overlaySettings]="overlaySettings"
            (selectionChanging)='handleSelection($event)'>
  @for (moneda of monedas; track moneda) {
    <igx-select-item [value]="moneda">
      {{moneda}}
    </igx-select-item>
  }
</igx-select>
